import "./cards.scss";

import { FunctionComponent, useState } from "react"
import { formatAssetAmount } from "../../utils/decimal";
import { Bitcoin, PlusCircle, Wallet } from "lucide-react";
import { useNavigate } from "react-router-dom";
import AddValueModal from "../modal/modal-add-value/modal-add-value";
import { useRole } from "../../auth/useRole";

interface CardListHorizontalProps {
  items: any[];
  showDeposits?: boolean;
  showWalletCount?: boolean;
}

const CardListHorizontal: FunctionComponent<CardListHorizontalProps> = ({
    items,
    showDeposits = true,
    showWalletCount = false,
}) => {

    const navigate = useNavigate();
    // Adicionar credito e exclusivo do owner (o backend tambem bloqueia).
    const { role } = useRole();
    const canAddCredit = role === "owner";
    const [activeModal, setActiveModal] = useState<{ walletId: number; currency: string, currencySymbol?: string, currencyId: number, organizationId: number } | null>(null);

    const iconByWallet = ( walletName: string ) => {
        switch( walletName ) {
            case 'BRL': 
                return <span className="wallet-icon">R$</span>;
            case 'USDT': 
                return <span className="wallet-icon">₮</span>;
            case 'BTC': 
                return <span className="wallet-icon">
                    <Bitcoin size={16} />
                </span>;
            case 'TRX':
                return <span className="wallet-icon">
                    <svg viewBox="0 0 256 256" aria-hidden="true">
                        <path fill="currentColor" d="M249.6 38.4L139.7 7.3a14.6 14.6 0 0 0-8.6 0L21.3 38.4a14.7 14.7 0 0 0-9.6 18.5l102.4 185.6a14.7 14.7 0 0 0 25.8 0L240.2 56.9a14.7 14.7 0 0 0-9.6-18.5zM128 24.2l92.7 26.2-84.4 15.7L128 24.2zm-9.6 46.7L36.7 54.9l79.6 16zM41.6 70.9l76.9 135.6L19.8 67.4zm95.9 135.6L214.4 70.9l21.8-3.5z"/>
                    </svg>
                </span>;
            case 'ETH':
                return <span className="wallet-icon">
                    <svg viewBox="0 0 256 417" aria-hidden="true">
                        <path fill="currentColor" d="M127.9 0L124.1 13.1V279.6L127.9 283.4L255.8 210.9z"/>
                        <path fill="currentColor" d="M127.9 0L0 210.9L127.9 283.4V150.9z"/>
                        <path fill="currentColor" d="M127.9 306.4L125.8 308.9V412.4L127.9 416.8L255.9 233.6z"/>
                        <path fill="currentColor" d="M127.9 416.8V306.4L0 233.6z"/>
                    </svg>
                </span>;
            default:
                return <span className="wallet-icon">
                    <Wallet size={16} />
                </span>;
        }
    };

    const goToUrl = (path:string) => {
        navigate("/clients/"+path);
    }

    if (!items) return (<></>)

    return(
        <> 
            { items && items.length > 0 && items.map( (entity:any, index) => (
                <div className="client-info" key={index}>

                    <h2 className="flex sb">
                        { entity.name.toUpperCase() }
                        { showDeposits && (
                            <div className="buttons">
                                <div className="btn access" onClick={ () => goToUrl('deposits/'+entity.id) }>
                                    Listar Depositos
                                </div>
                            </div>
                        )}
                    </h2>
                    <ol>
                        { entity.wallets.map( (wallet:any, ind:any) => (
                            <li className="wallet-info-card" key={ind}>
                                <p className="label">{ wallet.nickname }</p>

                                <p className="amount">
                                    <small>Saldo:</small>
                                    <span className={`currency ${wallet.balance < 0 ? 'negative' : 'positive'}`}>
                                        { formatAssetAmount(wallet.balance, wallet.asset?.symbol) }
                                    </span>
                                </p>

                                <div className="badge">
                                    { iconByWallet(wallet.asset.name) }
                                    { wallet.asset.name }
                                </div>

                                {canAddCredit && <button
                                    className="btn-add-value"
                                    onClick={() => setActiveModal(
                                        { 
                                            walletId: wallet.id, 
                                            currency: wallet.asset.name, 
                                            currencySymbol: wallet.asset.symbol,
                                            currencyId:wallet.asset.id, 
                                            organizationId: entity.organizationUsers[0]?.organization.id 
                                        }
                                    )}
                                >
                                    <PlusCircle size={14} /> Adicionar Valor
                                </button>}

                            </li>
                        ))}
                    </ol>

                    { showWalletCount && entity.wallets?.length > 0 && (
                        <div
                            className="wallet-count"
                            role="img"
                            aria-label={`${entity.wallets.length} ${entity.wallets.length === 1 ? 'carteira' : 'carteiras'}`}
                        >
                            { entity.wallets.map( (wallet:any, ind:any) => (
                                <span className="dot" key={wallet.id ?? ind} aria-hidden="true" />
                            ))}
                        </div>
                    )}
                </div>
            ))}
            { items && items.length === 0 && (
                <p className="flex-item center no-suuplier">Sem nenhum fornecedor cadastrado</p>
            )}

            { activeModal && (
                <AddValueModal
                    walletId={activeModal.walletId}
                    currency={activeModal.currency}
                    currencySymbol={activeModal.currencySymbol}
                    currencyId={activeModal.currencyId}
                    organizationId={activeModal.organizationId}
                    onClose={() => setActiveModal(null)}
                />
            )}
        </>
    )
}

export default CardListHorizontal;